import type { ChatUiMultiLeg } from '@voll-intelligence/genui-contract';
import type {
  ExplorerTripGeometry,
  FlightExplorerRequest,
  FlightSearchParams,
} from '@voll-intelligence/intelligence-ui-kit';

/**
 * Helpers PUROS da abertura do explorer a partir do card multi. Vivem fora de
 * `flight_multi_offers.tsx` porque aquele arquivo está no teto de linhas
 * (`max-lines-baseline`), e a montagem do pedido é código sem React.
 */

/**
 * O roteiro do card no vocabulário de geometria do explorer — a construção é UMA
 * SÓ: comparar confirm × card é comparar o que o explorer abriu com o que ele
 * fechou, e duas cópias desta montagem divergiriam no primeiro campo novo — a
 * tela avisaria uma coisa e o dispatch faria outra. Roteiro de UM trecho (o
 * schema permite, `legs.min(1)`) é `one_way`: um stepper de um passo não descreve
 * viagem nenhuma.
 */
export function tripOf(legs: ChatUiMultiLeg[]): ExplorerTripGeometry {
  return {
    mode: legs.length > 1 ? 'multi_leg' : 'one_way',
    legs: legs.map((l) => ({
      origin: l.origin,
      destination: l.destination,
      departDate: l.departDate,
    })),
  };
}

/**
 * O `request` com que o drawer abre. A geometria sai de {@link tripOf}; cabine,
 * sujeito da política e a LINHAGEM do card (`itineraryChallengeId`, que cada
 * busca de perna leva ao BFF em `FlightSearchParams.itinerary`) são do PEDIDO,
 * não da viagem: entram por fora e `sameTripGeometry` não os lê — nenhum deles
 * pesa no confirm igual × divergente.
 */
export function explorerOpenRequest(
  legs: ChatUiMultiLeg[],
  search: Pick<FlightSearchParams, 'cabin' | 'policyTravelerId'> | undefined,
  challengeId: string,
): FlightExplorerRequest {
  return {
    ...tripOf(legs),
    ...(search?.cabin ? { cabin: search.cabin } : {}),
    ...(search?.policyTravelerId ? { policyTravelerId: search.policyTravelerId } : {}),
    itineraryChallengeId: challengeId,
  };
}
